/**
 * Auto-generated Pipedrive constants
 * Generated on: 2026-02-16T13:20:42.905Z
 *
 * This file contains:
 * - STAGES enum and STAGES_ORDER array
 * - CUSTOM_FIELD_KEYS object for custom deal fields
 * - Enum field mappings (option IDs to labels)
 *
 * DO NOT EDIT THIS FILE MANUALLY - Run 'pnpm generate:pipedrive' to regenerate.
 *
 * Usage:
 *   import { STAGES, STAGES_ORDER, CUSTOM_FIELD_KEYS, KYB_PASSED } from "data/clients/pipedrive";
 *
 *   // Check deal stage
 *   if (deal.stage_id === STAGES.KYB_APPROVED) { }
 *
 *   // Access custom field
 *   const loanAmount = deal[CUSTOM_FIELD_KEYS.LOAN_AMOUNT];
 *
 *   // Compare enum values
 *   if (deal.kybPassed === KYB_PASSED.Yes) { }
 */

/**
 * Pipedrive deal stages
 * Auto-generated from GET /stages API
 */
export enum STAGES {
  DEAD_DEPRIORITIZED = 28,
  QUALIFIED = 30,
  FUNDED_COMPLIANT = 42,
  MONITORING = 27,
  CONTACT_MADE = 31,
  SPECIAL_SERVICING = 47,
  NEW_LEAD = 6,
  DEMO_SCHEDULED = 32,
  DEFAULT = 43,
  INTRO_CALL_SCHEDULED = 36,
  PROPOSAL_MADE = 33,
  AUCTIONED = 44,
  INTRO_CALL_HELD = 7,
  NEGOTIATIONS_STARTED = 34,
  RESOLD = 45,
  TERM_SHEET_SENT = 11,
  REPAID = 46,
  TERM_SHEET_SIGNED = 41,
  PO_DEPOSIT_PLACED = 40,
  INSTALLED = 39,
  FUNDED = 17,
}

/**
 * Stages in pipeline order (sorted by order_nr)
 * Auto-generated from GET /stages API
 */
export const STAGES_ORDER: readonly STAGES[] = [
  STAGES.DEAD_DEPRIORITIZED,
  STAGES.QUALIFIED,
  STAGES.FUNDED_COMPLIANT,
  STAGES.MONITORING,
  STAGES.CONTACT_MADE,
  STAGES.SPECIAL_SERVICING,
  STAGES.NEW_LEAD,
  STAGES.DEMO_SCHEDULED,
  STAGES.DEFAULT,
  STAGES.INTRO_CALL_SCHEDULED,
  STAGES.PROPOSAL_MADE,
  STAGES.AUCTIONED,
  STAGES.INTRO_CALL_HELD,
  STAGES.NEGOTIATIONS_STARTED,
  STAGES.RESOLD,
  STAGES.TERM_SHEET_SENT,
  STAGES.REPAID,
  STAGES.TERM_SHEET_SIGNED,
  STAGES.PO_DEPOSIT_PLACED,
  STAGES.INSTALLED,
  STAGES.FUNDED,
] as const;

/**
 * Mapping of stage IDs to their display names
 * Auto-generated from GET /stages API
 */
export const STAGES_LABELS: Record<STAGES, string> = {
  [STAGES.DEAD_DEPRIORITIZED]: "Dead/Deprioritized",
  [STAGES.QUALIFIED]: "Qualified",
  [STAGES.FUNDED_COMPLIANT]: "Funded - Compliant",
  [STAGES.MONITORING]: "Monitoring",
  [STAGES.CONTACT_MADE]: "Contact Made",
  [STAGES.SPECIAL_SERVICING]: "Special Servicing",
  [STAGES.NEW_LEAD]: "New Lead",
  [STAGES.DEMO_SCHEDULED]: "Demo Scheduled",
  [STAGES.DEFAULT]: "Default",
  [STAGES.INTRO_CALL_SCHEDULED]: "Intro Call Scheduled",
  [STAGES.PROPOSAL_MADE]: "Proposal Made",
  [STAGES.AUCTIONED]: "Auctioned",
  [STAGES.INTRO_CALL_HELD]: "Intro Call Held",
  [STAGES.NEGOTIATIONS_STARTED]: "Negotiations Started",
  [STAGES.RESOLD]: "Resold",
  [STAGES.TERM_SHEET_SENT]: "Term Sheet Sent",
  [STAGES.REPAID]: "Repaid",
  [STAGES.TERM_SHEET_SIGNED]: "Term Sheet Signed",
  [STAGES.PO_DEPOSIT_PLACED]: "PO Deposit Placed",
  [STAGES.INSTALLED]: "Installed",
  [STAGES.FUNDED]: "Funded",
} as const;

/**
 * Pipedrive custom field keys (hash keys for custom deal fields)
 * Auto-generated from GET /dealFields API
 * 
 * Usage: Use these keys when reading/writing custom fields on deals
 */
export const CUSTOM_FIELD_KEYS = {
  /** Probability of Close (enum) */
  PROBABILITY_OF_CLOSE: "347cda1150789af5a19a0483a0063db455aad424",
  /** Loan Amount (monetary) */
  LOAN_AMOUNT: "c7ba2b427721274d6a05693bb9c8be43b3c8d6bb",
  /** Duration (mo) (double) */
  DURATION_MO: "4db917ea3f87415149a584a234424057f414b400",
  /** Structuring Fee (%) (double) */
  STRUCTURING_FEE: "86c109b0d080eb8e003ea9b829addc2654cc84b2",
  /** APR (%) (double) */
  APR: "0251dbcc0b6dbe1db544ed942a325c38448462c7",
  /** LTV (%) (double) */
  LTV: "485dff1c220fdbe9cffabc99bf9d365b18bdbe91",
  /** Originator Fee (monetary) */
  ORIGINATOR_FEE: "f03a3b50901514e30756b1097d9b8521e7052532",
  /** Current Notes (text) */
  CURRENT_NOTES: "80a581aedb12a3cf5a84248b21184ccdc6f7737a",
  /** Deal Type (varchar) */
  DEAL_TYPE: "fc69cb65632772dd75a83be0fa67c3cd9b61c35f",
  /** Future Pipeline (monetary) */
  FUTURE_PIPELINE: "61396706d00521f23124ed1c65b10e9d40a88578",
  /** isTEST (enum) */
  ISTEST: "2b26af4354874e97018e9aad208457f8bf2d5416",
  /** Server OEM (varchar) */
  SERVER_OEM: "257403e8c21b51bfccc50bbfa0a397cba52cdeed",
  /** Collateral Value (double) */
  COLLATERAL_VALUE: "182e44183e1106306608cfc6adefc69b4cd9f222",
  /** Chip/Server Type (varchar) */
  CHIP_SERVER_TYPE: "4f45852f2912be88c6211b93d42f081a59bfc267",
  /** Count (Server) (double) */
  COUNT_SERVER: "5a50c6f2b77cee65923fa03809139bf05f45357c",
  /** GPUs per Server (double) */
  GPUS_PER_SERVER: "f96cbd753e796a5157505173c7dc342cb33268ae",
  /** Ancillary Cost (double) */
  ANCILLARY_COST: "1540eb49b704a51972d303b87c447c03eb496578",
  /** Unit Price (double) */
  UNIT_PRICE: "90bd60d5654d2333a99c087a8a7a34127a5a0cd5",
  /** GPU Age (varchar) */
  GPU_AGE: "458a35cb34823a80c57d9867b3360adbfe130b12",
  /** Hardware Shipped? (enum) */
  HARDWARE_SHIPPED: "e7d7148683c30552ce53721264b3de452939fa1d",
  /** Estimated/Actual Delivery Date (date) */
  ESTIMATED_ACTUAL_DELIVERY_DATE: "5625ed28635a7c15047e116c87049fd2acc0e066",
  /** Hardware Installed and Burn in Complete? (enum) */
  HARDWARE_INSTALLED_AND_BURN_IN_COMPLETE: "f1d989b84b2ad2564e09fd93b99db1ab8d30a83c",
  /** Equipment Warranty Received (enum) */
  EQUIPMENT_WARRANTY_RECEIVED: "00af81541df009d41ee5f5505aa17d7c4d98040b",
  /** Data Center Operator (varchar) */
  DATA_CENTER_OPERATOR: "f25ed596338e99f70ee81da4a8fef2b5fd2b30ce",
  /** Data Center Country (varchar) */
  DATA_CENTER_COUNTRY: "7804eb5e9b4ae698883fb3ea3920a2fb7233dbcf",
  /** Data Center Address (address) */
  DATA_CENTER_ADDRESS: "c4844806c3bb848d392dda83953e2b4a3c158d7f",
  /** Data Center Tier (varchar) */
  DATA_CENTER_TIER: "0b44dc6ac4b203192b96b3e07622676fc518506d",
  /** Offtaker (enum) */
  OFFTAKER: "98a633ff60f37d8478b5757b2bc6d5f6857d5dc8",
  /** Name of Offtaker (varchar) */
  NAME_OF_OFFTAKER: "8022b3c1d2cce5d1ea91655232cd30ae1c7ad8cf",
  /** Length of Contract (Months) (varchar) */
  LENGTH_OF_CONTRACT_MONTHS: "872f18fb62af45e9f90b11012bfbc3b31889409e",
  /** Contract Rate ($/hr/GPU) (monetary) */
  CONTRACT_RATE_HR_GPU: "06d14a917c8e4a6570bdfb35486eb494f02ad9e3",
  /** Up Front Deposit ($) (varchar) */
  UP_FRONT_DEPOSIT: "1a7ea14d90ab45a5ddee44b604f4db2b64148c12",
  /** Up Front Deposit (%) (varchar) */
  UP_FRONT_DEPOSIT_78: "349aebfa714591a3d1f5bfb3243509bf84643146",
  /** Recourse (varchar) */
  RECOURSE: "f55b053e6d92e537b9d97ea1da5189a2689de8ed",
  /** Equity Source (varchar) */
  EQUITY_SOURCE: "16605d8a16202560c73676853fa2c1961e8eec1c",
  /** Expected Closing Date of Fundraise (date) */
  EXPECTED_CLOSING_DATE_OF_FUNDRAISE: "683186672f728eda129612b97f7a21a818083510",
  /** Liquid Assets Behind Guarantee (varchar) */
  LIQUID_ASSETS_BEHIND_GUARANTEE: "ab4cec1179607252d9d751afb9dbb01af67a1aa7",
  /** Guarantee Type (varchar) */
  GUARANTEE_TYPE: "949a3caec752ecc66a47b28a412ec33c0425adab",
  /** NDA_status (enum) */
  NDA_STATUS: "d7d3dfaba5ea7bb23e45a34a8224fbefad14514c",
  /** NDA_override (text) */
  NDA_OVERRIDE: "9824b0134c3c8a4f541423a78b1dda973d7c1a80",
  /** NDA_envelopeid (varchar) */
  NDA_ENVELOPEID: "548aadb064a96286352fc784d85e8f933cc0c697",
  /** TermSheet_status (enum) */
  TERMSHEET_STATUS: "c19e2651065b0b97646dcec0e7e8528d7c29703c",
  /** TermSheet_override (text) */
  TERMSHEET_OVERRIDE: "510363c4a3c58f3195b849853f0c8fc824e16eac",
  /** TermSheet_envelopeid (varchar) */
  TERMSHEET_ENVELOPEID: "0a120e71d75d01344686022d64098741b5f4fd94",
  /** KYB_status (enum) */
  KYB_STATUS: "3c924d0009e3b4ca08591718a762c905eaa7fa19",
  /** KYB_override (text) */
  KYB_OVERRIDE: "18818a1b69072b020d8eccc379e140021830e07f",
  /** DataCenterOnePager_status (enum) */
  DATACENTERONEPAGER_STATUS: "d5de2fef33e9024ee89b416601dc31a979a3a643",
  /** PurchaseOrder_status (enum) */
  PURCHASEORDER_STATUS: "a7b35aa3f095016acce6ce4ea2c3b864f92f64cb",
  /** OEM Payment Terms (enum) */
  OEM_PAYMENT_TERMS: "57b1601d582819af391f6ddb4fe5b41368dfb99f",
  /** Onramp/Offramp (enum) */
  ONRAMP_OFFRAMP: "e00ba5b36adfa213c38785d96abb657fec797d9d",
  /** ColocationAgreement_status (enum) */
  COLOCATIONAGREEMENT_STATUS: "243c01f5bee4f2eda200a03cb52295d14a44fab4",
  /** Offtake Agreement (enum) */
  OFFTAKE_AGREEMENT: "bfbca09586600306461ef18e0b9e469480f67df4",
  /** Bridge Loan (enum) */
  BRIDGE_LOAN: "209b2db5abba2b15705e7a915f4b3f94afa710e8",
  /** Jurisdiction Review (enum) */
  JURISDICTION_REVIEW: "33d80ad890272a94b3b87889b8f3e4b7623d68d7",
  /** SPV One Stop (enum) */
  SPV_ONE_STOP: "086488add8ab8c59b89a7d90d650463e6fe97c10",
  /** SPV LLC Name (varchar) */
  SPV_LLC_NAME: "95be5fcc216b8ccb69f83f928dd1d1f2f9252bf3",
  /** SPVOneStop_status (enum) */
  SPVONESTOP_STATUS: "5bfcb8aad8382fffa18e4bc2b22ed0211576afd9",
  /** SPVOneStop_override (text) */
  SPVONESTOP_OVERRIDE: "e88c0dd871fdd9a8c35ab0ebb915c289e3a31cbc",
  /** SPVOneStop_envelopeid (varchar) */
  SPVONESTOP_ENVELOPEID: "25bf0bffbec281b5107abb7de7736d82177d47fb",
  /** Certificate of Formation (enum) */
  CERTIFICATE_OF_FORMATION: "6f1ca719cef3b5ec53f9f4394bbf0fd767155819",
  /** LLC Agreement (enum) */
  LLC_AGREEMENT: "92c7deb00ea03b7727ff5f40d0343e13dc8736cc",
  /** IM Staffing Agreement (enum) */
  IM_STAFFING_AGREEMENT: "df089dbd00aeff25936cd7e52727446e9170e0d0",
  /** IM Indemnity Agreement (enum) */
  IM_INDEMNITY_AGREEMENT: "7039c4e89839a3eac90c0652af8a1607224b5430",
  /** Approval of RA and IM (enum) */
  APPROVAL_OF_RA_AND_IM: "e65448320aed54244c1039be421dd682ae5e699e",
  /** EIN Letter (enum) */
  EIN_LETTER: "6dd9d85313fd1b3930dd34f86a266286b32b5320",
  /** CustomerServiceAgreement_status (enum) */
  CUSTOMERSERVICEAGREEMENT_STATUS: "be50b30f04dde52371f8784399cfdd9c6f6800ef",
  /** CustomerServiceAgreement_override (text) */
  CUSTOMERSERVICEAGREEMENT_OVERRIDE: "36479b0603f436d1d20bca50ea173c5a1d87e891",
  /** CustomerServiceAgreement_envelopeId (varchar) */
  CUSTOMERSERVICEAGREEMENT_ENVELOPEID: "2af39f45a35228aad4da8d1d1b3106f13a3256e8",
  /** Proof of Order (enum) */
  PROOF_OF_ORDER: "8f0b5ffa81cfb4df8a6b66cd3037fc76342be42a",
  /** SPV is PO Purchaser (enum) */
  SPV_IS_PO_PURCHASER: "315c4043bf5696debea1933f22d67b6863f6808c",
  /** Proceeds Escrowed (text) */
  PROCEEDS_ESCROWED: "1927de94249330f77b0ae22ba2b9c7193515384f",
  /** SaleAndContributionAgreement_status (enum) */
  SALEANDCONTRIBUTIONAGREEMENT_STATUS: "594248e3f510eb68f00d23fd8a8d021c0c7cddc9",
  /** SaleAndContributionAgreement_override (text) */
  SALEANDCONTRIBUTIONAGREEMENT_OVERRIDE: "59f6c5c6127eb6f1549e0ccc466ab57d3d07ff8c",
  /** SaleAndContributionAgreement_envelopeId (varchar) */
  SALEANDCONTRIBUTIONAGREEMENT_ENVELOPEID: "67754d0090db265b36355e772b46c47f3495809a",
  /** WarehouseReceipt_status (enum) */
  WAREHOUSERECEIPT_STATUS: "11cf615dae47c7843cdee9cae1fa0d0649382c9e",
  /** WarehouseReceipt_override (text) */
  WAREHOUSERECEIPT_OVERRIDE: "f048280669ca77e0deafce00abf71cd458161541",
  /** Aravolta (enum) */
  ARAVOLTA: "163f44e955eccb05e31b3704ca583b027ca49ef0",
  /** Aravolta_status (enum) */
  ARAVOLTA_STATUS: "0c2321c59c01f1d92574379674d3ee593518cd7c",
  /** Insurance Quote or NRAI Indemnity (enum) */
  INSURANCE_QUOTE_OR_NRAI_INDEMNITY: "bc843483c56f48e64a56389ae236332a2bda20a3",
  /** Assets Added to Master Insurance (enum) */
  ASSETS_ADDED_TO_MASTER_INSURANCE: "789ea5e8e06ecd18a78ecd5099bd88d878976edd",
  /** Assets Tokenized and Sent (varchar) */
  ASSETS_TOKENIZED_AND_SENT: "3279025ff2c6fecc796f6bb9297d34a2035e4047",
  /** Loan Executed (text) */
  LOAN_EXECUTED: "cd49a469a17ab951614ea9b59527b23959c59d18",
  /** MLA Received? (enum) */
  MLA_RECEIVED: "7f6628aaa8902d5c6d8ea95f2601601da8c47269",
  /** API Last Updated (varchar) */
  API_LAST_UPDATED: "15fe4dc278e7d2a439da2e296c2b5bb0861f9e67",
  /** API Updated Fields (text) */
  API_UPDATED_FIELDS: "3e3aba22ac45d2a75c28a637c68f853cade51f51",
} as const;

/**
 * Mapping of custom field keys to their display names
 * Auto-generated from GET /dealFields API
 */
export const CUSTOM_FIELD_LABELS: Record<string, string> = {
  "347cda1150789af5a19a0483a0063db455aad424": "Probability of Close",
  "c7ba2b427721274d6a05693bb9c8be43b3c8d6bb": "Loan Amount",
  "4db917ea3f87415149a584a234424057f414b400": "Duration (mo)",
  "86c109b0d080eb8e003ea9b829addc2654cc84b2": "Structuring Fee (%)",
  "0251dbcc0b6dbe1db544ed942a325c38448462c7": "APR (%)",
  "485dff1c220fdbe9cffabc99bf9d365b18bdbe91": "LTV (%)",
  "f03a3b50901514e30756b1097d9b8521e7052532": "Originator Fee",
  "80a581aedb12a3cf5a84248b21184ccdc6f7737a": "Current Notes",
  "fc69cb65632772dd75a83be0fa67c3cd9b61c35f": "Deal Type",
  "61396706d00521f23124ed1c65b10e9d40a88578": "Future Pipeline",
  "2b26af4354874e97018e9aad208457f8bf2d5416": "isTEST",
  "257403e8c21b51bfccc50bbfa0a397cba52cdeed": "Server OEM",
  "182e44183e1106306608cfc6adefc69b4cd9f222": "Collateral Value",
  "4f45852f2912be88c6211b93d42f081a59bfc267": "Chip/Server Type",
  "5a50c6f2b77cee65923fa03809139bf05f45357c": "Count (Server)",
  "f96cbd753e796a5157505173c7dc342cb33268ae": "GPUs per Server",
  "1540eb49b704a51972d303b87c447c03eb496578": "Ancillary Cost",
  "90bd60d5654d2333a99c087a8a7a34127a5a0cd5": "Unit Price",
  "458a35cb34823a80c57d9867b3360adbfe130b12": "GPU Age",
  "e7d7148683c30552ce53721264b3de452939fa1d": "Hardware Shipped?",
  "5625ed28635a7c15047e116c87049fd2acc0e066": "Estimated/Actual Delivery Date",
  "f1d989b84b2ad2564e09fd93b99db1ab8d30a83c": "Hardware Installed and Burn in Complete?",
  "00af81541df009d41ee5f5505aa17d7c4d98040b": "Equipment Warranty Received",
  "f25ed596338e99f70ee81da4a8fef2b5fd2b30ce": "Data Center Operator",
  "7804eb5e9b4ae698883fb3ea3920a2fb7233dbcf": "Data Center Country",
  "c4844806c3bb848d392dda83953e2b4a3c158d7f": "Data Center Address",
  "0b44dc6ac4b203192b96b3e07622676fc518506d": "Data Center Tier",
  "98a633ff60f37d8478b5757b2bc6d5f6857d5dc8": "Offtaker",
  "8022b3c1d2cce5d1ea91655232cd30ae1c7ad8cf": "Name of Offtaker",
  "872f18fb62af45e9f90b11012bfbc3b31889409e": "Length of Contract (Months)",
  "06d14a917c8e4a6570bdfb35486eb494f02ad9e3": "Contract Rate ($/hr/GPU)",
  "1a7ea14d90ab45a5ddee44b604f4db2b64148c12": "Up Front Deposit ($)",
  "349aebfa714591a3d1f5bfb3243509bf84643146": "Up Front Deposit (%)",
  "f55b053e6d92e537b9d97ea1da5189a2689de8ed": "Recourse",
  "16605d8a16202560c73676853fa2c1961e8eec1c": "Equity Source",
  "683186672f728eda129612b97f7a21a818083510": "Expected Closing Date of Fundraise",
  "ab4cec1179607252d9d751afb9dbb01af67a1aa7": "Liquid Assets Behind Guarantee",
  "949a3caec752ecc66a47b28a412ec33c0425adab": "Guarantee Type",
  "d7d3dfaba5ea7bb23e45a34a8224fbefad14514c": "NDA_status",
  "9824b0134c3c8a4f541423a78b1dda973d7c1a80": "NDA_override",
  "548aadb064a96286352fc784d85e8f933cc0c697": "NDA_envelopeid",
  "c19e2651065b0b97646dcec0e7e8528d7c29703c": "TermSheet_status",
  "510363c4a3c58f3195b849853f0c8fc824e16eac": "TermSheet_override",
  "0a120e71d75d01344686022d64098741b5f4fd94": "TermSheet_envelopeid",
  "3c924d0009e3b4ca08591718a762c905eaa7fa19": "KYB_status",
  "18818a1b69072b020d8eccc379e140021830e07f": "KYB_override",
  "d5de2fef33e9024ee89b416601dc31a979a3a643": "DataCenterOnePager_status",
  "a7b35aa3f095016acce6ce4ea2c3b864f92f64cb": "PurchaseOrder_status",
  "57b1601d582819af391f6ddb4fe5b41368dfb99f": "OEM Payment Terms",
  "e00ba5b36adfa213c38785d96abb657fec797d9d": "Onramp/Offramp",
  "243c01f5bee4f2eda200a03cb52295d14a44fab4": "ColocationAgreement_status",
  "bfbca09586600306461ef18e0b9e469480f67df4": "Offtake Agreement",
  "209b2db5abba2b15705e7a915f4b3f94afa710e8": "Bridge Loan",
  "33d80ad890272a94b3b87889b8f3e4b7623d68d7": "Jurisdiction Review",
  "086488add8ab8c59b89a7d90d650463e6fe97c10": "SPV One Stop",
  "95be5fcc216b8ccb69f83f928dd1d1f2f9252bf3": "SPV LLC Name",
  "5bfcb8aad8382fffa18e4bc2b22ed0211576afd9": "SPVOneStop_status",
  "e88c0dd871fdd9a8c35ab0ebb915c289e3a31cbc": "SPVOneStop_override",
  "25bf0bffbec281b5107abb7de7736d82177d47fb": "SPVOneStop_envelopeid",
  "6f1ca719cef3b5ec53f9f4394bbf0fd767155819": "Certificate of Formation",
  "92c7deb00ea03b7727ff5f40d0343e13dc8736cc": "LLC Agreement",
  "df089dbd00aeff25936cd7e52727446e9170e0d0": "IM Staffing Agreement",
  "7039c4e89839a3eac90c0652af8a1607224b5430": "IM Indemnity Agreement",
  "e65448320aed54244c1039be421dd682ae5e699e": "Approval of RA and IM",
  "6dd9d85313fd1b3930dd34f86a266286b32b5320": "EIN Letter",
  "be50b30f04dde52371f8784399cfdd9c6f6800ef": "CustomerServiceAgreement_status",
  "36479b0603f436d1d20bca50ea173c5a1d87e891": "CustomerServiceAgreement_override",
  "2af39f45a35228aad4da8d1d1b3106f13a3256e8": "CustomerServiceAgreement_envelopeId",
  "8f0b5ffa81cfb4df8a6b66cd3037fc76342be42a": "Proof of Order",
  "315c4043bf5696debea1933f22d67b6863f6808c": "SPV is PO Purchaser",
  "1927de94249330f77b0ae22ba2b9c7193515384f": "Proceeds Escrowed",
  "594248e3f510eb68f00d23fd8a8d021c0c7cddc9": "SaleAndContributionAgreement_status",
  "59f6c5c6127eb6f1549e0ccc466ab57d3d07ff8c": "SaleAndContributionAgreement_override",
  "67754d0090db265b36355e772b46c47f3495809a": "SaleAndContributionAgreement_envelopeId",
  "11cf615dae47c7843cdee9cae1fa0d0649382c9e": "WarehouseReceipt_status",
  "f048280669ca77e0deafce00abf71cd458161541": "WarehouseReceipt_override",
  "163f44e955eccb05e31b3704ca583b027ca49ef0": "Aravolta",
  "0c2321c59c01f1d92574379674d3ee593518cd7c": "Aravolta_status",
  "bc843483c56f48e64a56389ae236332a2bda20a3": "Insurance Quote or NRAI Indemnity",
  "789ea5e8e06ecd18a78ecd5099bd88d878976edd": "Assets Added to Master Insurance",
  "3279025ff2c6fecc796f6bb9297d34a2035e4047": "Assets Tokenized and Sent",
  "cd49a469a17ab951614ea9b59527b23959c59d18": "Loan Executed",
  "7f6628aaa8902d5c6d8ea95f2601601da8c47269": "MLA Received?",
  "15fe4dc278e7d2a439da2e296c2b5bb0861f9e67": "API Last Updated",
  "3e3aba22ac45d2a75c28a637c68f853cade51f51": "API Updated Fields",
} as const;

/**
 * Source origin
 * Field ID: 34
 * Field Key: origin
 */
export const SOURCE_ORIGIN = {
  "Manually created": "ManuallyCreated",
  Import: "Import",
  API: "API",
  Automation: "Automation",
  Marketplace: "Marketplace",
  Prospector: "Prospector",
  "Lead suggestions": "LeadSuggestion",
  "Web Forms": "WebForms",
  Chatbot: "Chatbot",
  "Live Chat": "LiveChat",
  "Web Visitors": "WebVisitors",
  Campaigns: "Campaigns",
  "Messaging inbox": "MessagingInbox",
} as const;

export const SOURCE_ORIGIN_LABELS: Record<string, string> = {
  "ManuallyCreated": "Manually created",
  "Import": "Import",
  "API": "API",
  "Automation": "Automation",
  "Marketplace": "Marketplace",
  "Prospector": "Prospector",
  "LeadSuggestion": "Lead suggestions",
  "WebForms": "Web Forms",
  "Chatbot": "Chatbot",
  "LiveChat": "Live Chat",
  "WebVisitors": "Web Visitors",
  "Campaigns": "Campaigns",
  "MessagingInbox": "Messaging inbox",
} as const;

export const SOURCE_ORIGIN_OPTIONS = [
  { label: "Manually created", value: "ManuallyCreated" },
  { label: "Import", value: "Import" },
  { label: "API", value: "API" },
  { label: "Automation", value: "Automation" },
  { label: "Marketplace", value: "Marketplace" },
  { label: "Prospector", value: "Prospector" },
  { label: "Lead suggestions", value: "LeadSuggestion" },
  { label: "Web Forms", value: "WebForms" },
  { label: "Chatbot", value: "Chatbot" },
  { label: "Live Chat", value: "LiveChat" },
  { label: "Web Visitors", value: "WebVisitors" },
  { label: "Campaigns", value: "Campaigns" },
  { label: "Messaging inbox", value: "MessagingInbox" },
] as const;

/**
 * Source channel
 * Field ID: 36
 * Field Key: channel
 */
export const SOURCE_CHANNEL = {
  Prospector: 1,
  "Lead Suggestions": 2,
  "Web forms": 3,
  Chatbot: 4,
  "Live chat": 5,
  "Web visitors": 6,
  Campaigns: 7,
  Marketplace: 8,
  "Messaging Inbox": 9,
} as const;

export const SOURCE_CHANNEL_LABELS: Record<number, string> = {
  1: "Prospector",
  2: "Lead Suggestions",
  3: "Web forms",
  4: "Chatbot",
  5: "Live chat",
  6: "Web visitors",
  7: "Campaigns",
  8: "Marketplace",
  9: "Messaging Inbox",
} as const;

export const SOURCE_CHANNEL_OPTIONS = [
  { label: "Prospector", value: 1 },
  { label: "Lead Suggestions", value: 2 },
  { label: "Web forms", value: 3 },
  { label: "Chatbot", value: 4 },
  { label: "Live chat", value: 5 },
  { label: "Web visitors", value: 6 },
  { label: "Campaigns", value: 7 },
  { label: "Marketplace", value: 8 },
  { label: "Messaging Inbox", value: 9 },
] as const;

/**
 * Archive status
 * Field ID: 38
 * Field Key: is_archived
 */
export const ARCHIVE_STATUS = {
  "Not archived": false,
  Archived: true,
} as const;

export const ARCHIVE_STATUS_LABELS: Record<string, string> = {
  false: "Not archived",
  true: "Archived",
} as const;

export const ARCHIVE_STATUS_OPTIONS = [
  { label: "Not archived", value: false },
  { label: "Archived", value: true },
] as const;

/**
 * Probability of Close
 * Field ID: 117
 * Field Key: 347cda1150789af5a19a0483a0063db455aad424
 */
export const PROBABILITY_OF_CLOSE = {
  Low: 159,
  Medium: 160,
  High: 161,
} as const;

export const PROBABILITY_OF_CLOSE_LABELS: Record<number, string> = {
  159: "Low",
  160: "Medium",
  161: "High",
} as const;

export const PROBABILITY_OF_CLOSE_OPTIONS = [
  { label: "Low", value: 159 },
  { label: "Medium", value: 160 },
  { label: "High", value: 161 },
] as const;

/**
 * isTEST
 * Field ID: 115
 * Field Key: 2b26af4354874e97018e9aad208457f8bf2d5416
 */
export const ISTEST = {
  Yes: 153,
  No: 154,
} as const;

export const ISTEST_LABELS: Record<number, string> = {
  153: "Yes",
  154: "No",
} as const;

export const ISTEST_OPTIONS = [
  { label: "Yes", value: 153 },
  { label: "No", value: 154 },
] as const;

/**
 * Hardware Shipped?
 * Field ID: 98
 * Field Key: e7d7148683c30552ce53721264b3de452939fa1d
 */
export const HARDWARE_SHIPPED = {
  Yes: 100,
  No: 101,
} as const;

export const HARDWARE_SHIPPED_LABELS: Record<number, string> = {
  100: "Yes",
  101: "No",
} as const;

export const HARDWARE_SHIPPED_OPTIONS = [
  { label: "Yes", value: 100 },
  { label: "No", value: 101 },
] as const;

/**
 * Hardware Installed and Burn in Complete?
 * Field ID: 100
 * Field Key: f1d989b84b2ad2564e09fd93b99db1ab8d30a83c
 */
export const HARDWARE_INSTALLED_AND_BURN_IN_COMPLETE = {
  Yes: 102,
  No: 103,
} as const;

export const HARDWARE_INSTALLED_AND_BURN_IN_COMPLETE_LABELS: Record<number, string> = {
  102: "Yes",
  103: "No",
} as const;

export const HARDWARE_INSTALLED_AND_BURN_IN_COMPLETE_OPTIONS = [
  { label: "Yes", value: 102 },
  { label: "No", value: 103 },
] as const;

/**
 * Equipment Warranty Received
 * Field ID: 110
 * Field Key: 00af81541df009d41ee5f5505aa17d7c4d98040b
 */
export const EQUIPMENT_WARRANTY_RECEIVED = {
  Yes: 132,
  No: 133,
} as const;

export const EQUIPMENT_WARRANTY_RECEIVED_LABELS: Record<number, string> = {
  132: "Yes",
  133: "No",
} as const;

export const EQUIPMENT_WARRANTY_RECEIVED_OPTIONS = [
  { label: "Yes", value: 132 },
  { label: "No", value: 133 },
] as const;

/**
 * Offtaker
 * Field ID: 131
 * Field Key: 98a633ff60f37d8478b5757b2bc6d5f6857d5dc8
 */
export const OFFTAKER = {
  Contract: 194,
  "On-Demand": 195,
  Scoping: 197,
  "No offtake": 196,
} as const;

export const OFFTAKER_LABELS: Record<number, string> = {
  194: "Contract",
  195: "On-Demand",
  197: "Scoping",
  196: "No offtake",
} as const;

export const OFFTAKER_OPTIONS = [
  { label: "Contract", value: 194 },
  { label: "On-Demand", value: 195 },
  { label: "Scoping", value: 197 },
  { label: "No offtake", value: 196 },
] as const;

/**
 * NDA_status
 * Field ID: 116
 * Field Key: d7d3dfaba5ea7bb23e45a34a8224fbefad14514c
 */
export const NDA_STATUS = {
  Sent: 155,
  "Needs Review": 157,
  "Borrower Signed": 158,
  "Fully Executed": 156,
  "N/A": 227,
} as const;

export const NDA_STATUS_LABELS: Record<number, string> = {
  155: "Sent",
  157: "Needs Review",
  158: "Borrower Signed",
  156: "Fully Executed",
  227: "N/A",
} as const;

export const NDA_STATUS_OPTIONS = [
  { label: "Sent", value: 155 },
  { label: "Needs Review", value: 157 },
  { label: "Borrower Signed", value: 158 },
  { label: "Fully Executed", value: 156 },
  { label: "N/A", value: 227 },
] as const;

/**
 * TermSheet_status
 * Field ID: 113
 * Field Key: c19e2651065b0b97646dcec0e7e8528d7c29703c
 */
export const TERMSHEET_STATUS = {
  Sent: 138,
  "Needs Review": 139,
  "Borrower Signed": 140,
  "Fully Executed": 141,
  "N/A": 228,
} as const;

export const TERMSHEET_STATUS_LABELS: Record<number, string> = {
  138: "Sent",
  139: "Needs Review",
  140: "Borrower Signed",
  141: "Fully Executed",
  228: "N/A",
} as const;

export const TERMSHEET_STATUS_OPTIONS = [
  { label: "Sent", value: 138 },
  { label: "Needs Review", value: 139 },
  { label: "Borrower Signed", value: 140 },
  { label: "Fully Executed", value: 141 },
  { label: "N/A", value: 228 },
] as const;

/**
 * KYB_status
 * Field ID: 118
 * Field Key: 3c924d0009e3b4ca08591718a762c905eaa7fa19
 */
export const KYB_STATUS = {
  "In Process": 163,
  Approved: 164,
  Rejected: 165,
  "N/A": 229,
} as const;

export const KYB_STATUS_LABELS: Record<number, string> = {
  163: "In Process",
  164: "Approved",
  165: "Rejected",
  229: "N/A",
} as const;

export const KYB_STATUS_OPTIONS = [
  { label: "In Process", value: 163 },
  { label: "Approved", value: 164 },
  { label: "Rejected", value: 165 },
  { label: "N/A", value: 229 },
] as const;

/**
 * DataCenterOnePager_status
 * Field ID: 89
 * Field Key: d5de2fef33e9024ee89b416601dc31a979a3a643
 */
export const DATACENTERONEPAGER_STATUS = {
  "Under Review": 58,
  "UW Comments": 57,
  Approved: 59,
  Rejected: 60,
  "N/A": 230,
} as const;

export const DATACENTERONEPAGER_STATUS_LABELS: Record<number, string> = {
  58: "Under Review",
  57: "UW Comments",
  59: "Approved",
  60: "Rejected",
  230: "N/A",
} as const;

export const DATACENTERONEPAGER_STATUS_OPTIONS = [
  { label: "Under Review", value: 58 },
  { label: "UW Comments", value: 57 },
  { label: "Approved", value: 59 },
  { label: "Rejected", value: 60 },
  { label: "N/A", value: 230 },
] as const;

/**
 * PurchaseOrder_status
 * Field ID: 104
 * Field Key: a7b35aa3f095016acce6ce4ea2c3b864f92f64cb
 */
export const PURCHASEORDER_STATUS = {
  "Under Review": 111,
  "UW Comments": 110,
  Approved: 112,
  Rejected: 113,
  "N/A": 233,
} as const;

export const PURCHASEORDER_STATUS_LABELS: Record<number, string> = {
  111: "Under Review",
  110: "UW Comments",
  112: "Approved",
  113: "Rejected",
  233: "N/A",
} as const;

export const PURCHASEORDER_STATUS_OPTIONS = [
  { label: "Under Review", value: 111 },
  { label: "UW Comments", value: 110 },
  { label: "Approved", value: 112 },
  { label: "Rejected", value: 113 },
  { label: "N/A", value: 233 },
] as const;

/**
 * OEM Payment Terms
 * Field ID: 124
 * Field Key: 57b1601d582819af391f6ddb4fe5b41368dfb99f
 */
export const OEM_PAYMENT_TERMS = {
  Net30: 181,
  No: 182,
  "N/A": 183,
} as const;

export const OEM_PAYMENT_TERMS_LABELS: Record<number, string> = {
  181: "Net30",
  182: "No",
  183: "N/A",
} as const;

export const OEM_PAYMENT_TERMS_OPTIONS = [
  { label: "Net30", value: 181 },
  { label: "No", value: 182 },
  { label: "N/A", value: 183 },
] as const;

/**
 * Onramp/Offramp
 * Field ID: 120
 * Field Key: e00ba5b36adfa213c38785d96abb657fec797d9d
 */
export const ONRAMP_OFFRAMP = {
  Coinbase: 177,
  No: 170,
} as const;

export const ONRAMP_OFFRAMP_LABELS: Record<number, string> = {
  177: "Coinbase",
  170: "No",
} as const;

export const ONRAMP_OFFRAMP_OPTIONS = [
  { label: "Coinbase", value: 177 },
  { label: "No", value: 170 },
] as const;

/**
 * ColocationAgreement_status
 * Field ID: 125
 * Field Key: 243c01f5bee4f2eda200a03cb52295d14a44fab4
 */
export const COLOCATIONAGREEMENT_STATUS = {
  "Under Review": 184,
  "UW Comments": 186,
  Approved: 185,
  Rejected: 187,
  "N/A": 232,
} as const;

export const COLOCATIONAGREEMENT_STATUS_LABELS: Record<number, string> = {
  184: "Under Review",
  186: "UW Comments",
  185: "Approved",
  187: "Rejected",
  232: "N/A",
} as const;

export const COLOCATIONAGREEMENT_STATUS_OPTIONS = [
  { label: "Under Review", value: 184 },
  { label: "UW Comments", value: 186 },
  { label: "Approved", value: 185 },
  { label: "Rejected", value: 187 },
  { label: "N/A", value: 232 },
] as const;

/**
 * Offtake Agreement
 * Field ID: 106
 * Field Key: bfbca09586600306461ef18e0b9e469480f67df4
 */
export const OFFTAKE_AGREEMENT = {
  "Under Review": 119,
  Approved: 120,
  "UW Comments": 118,
  Rejected: 121,
  "N/A": 234,
} as const;

export const OFFTAKE_AGREEMENT_LABELS: Record<number, string> = {
  119: "Under Review",
  120: "Approved",
  118: "UW Comments",
  121: "Rejected",
  234: "N/A",
} as const;

export const OFFTAKE_AGREEMENT_OPTIONS = [
  { label: "Under Review", value: 119 },
  { label: "Approved", value: 120 },
  { label: "UW Comments", value: 118 },
  { label: "Rejected", value: 121 },
  { label: "N/A", value: 234 },
] as const;

/**
 * Bridge Loan
 * Field ID: 122
 * Field Key: 209b2db5abba2b15705e7a915f4b3f94afa710e8
 */
export const BRIDGE_LOAN = {
  Yes: 173,
  Equity: 174,
  "N/A": 235,
} as const;

export const BRIDGE_LOAN_LABELS: Record<number, string> = {
  173: "Yes",
  174: "Equity",
  235: "N/A",
} as const;

export const BRIDGE_LOAN_OPTIONS = [
  { label: "Yes", value: 173 },
  { label: "Equity", value: 174 },
  { label: "N/A", value: 235 },
] as const;

/**
 * Jurisdiction Review
 * Field ID: 119
 * Field Key: 33d80ad890272a94b3b87889b8f3e4b7623d68d7
 */
export const JURISDICTION_REVIEW = {
  "Under Review": 166,
  "UW Comments": 226,
  Approved: 167,
  Rejected: 168,
  "N/A": 231,
} as const;

export const JURISDICTION_REVIEW_LABELS: Record<number, string> = {
  166: "Under Review",
  226: "UW Comments",
  167: "Approved",
  168: "Rejected",
  231: "N/A",
} as const;

export const JURISDICTION_REVIEW_OPTIONS = [
  { label: "Under Review", value: 166 },
  { label: "UW Comments", value: 226 },
  { label: "Approved", value: 167 },
  { label: "Rejected", value: 168 },
  { label: "N/A", value: 231 },
] as const;

/**
 * SPV One Stop
 * Field ID: 137
 * Field Key: 086488add8ab8c59b89a7d90d650463e6fe97c10
 */
export const SPV_ONE_STOP = {
  GPULoans: 200,
  Self: 201,
} as const;

export const SPV_ONE_STOP_LABELS: Record<number, string> = {
  200: "GPULoans",
  201: "Self",
} as const;

export const SPV_ONE_STOP_OPTIONS = [
  { label: "GPULoans", value: 200 },
  { label: "Self", value: 201 },
] as const;

/**
 * SPVOneStop_status
 * Field ID: 139
 * Field Key: 5bfcb8aad8382fffa18e4bc2b22ed0211576afd9
 */
export const SPVONESTOP_STATUS = {
  "Under Review": 203,
  "UW Comments": 211,
  Approved: 210,
  Rejected: 212,
  "N/A": 236,
} as const;

export const SPVONESTOP_STATUS_LABELS: Record<number, string> = {
  203: "Under Review",
  211: "UW Comments",
  210: "Approved",
  212: "Rejected",
  236: "N/A",
} as const;

export const SPVONESTOP_STATUS_OPTIONS = [
  { label: "Under Review", value: 203 },
  { label: "UW Comments", value: 211 },
  { label: "Approved", value: 210 },
  { label: "Rejected", value: 212 },
  { label: "N/A", value: 236 },
] as const;

/**
 * Certificate of Formation
 * Field ID: 87
 * Field Key: 6f1ca719cef3b5ec53f9f4394bbf0fd767155819
 */
export const CERTIFICATE_OF_FORMATION = {
  "Under Review": 50,
  "UW Comments": 152,
  Approved: 51,
  Rejected: 52,
  "N/A": 237,
} as const;

export const CERTIFICATE_OF_FORMATION_LABELS: Record<number, string> = {
  50: "Under Review",
  152: "UW Comments",
  51: "Approved",
  52: "Rejected",
  237: "N/A",
} as const;

export const CERTIFICATE_OF_FORMATION_OPTIONS = [
  { label: "Under Review", value: 50 },
  { label: "UW Comments", value: 152 },
  { label: "Approved", value: 51 },
  { label: "Rejected", value: 52 },
  { label: "N/A", value: 237 },
] as const;

/**
 * LLC Agreement
 * Field ID: 88
 * Field Key: 92c7deb00ea03b7727ff5f40d0343e13dc8736cc
 */
export const LLC_AGREEMENT = {
  "Under Review": 54,
  "UW Comments": 146,
  Approved: 55,
  Rejected: 56,
  "N/A": 238,
} as const;

export const LLC_AGREEMENT_LABELS: Record<number, string> = {
  54: "Under Review",
  146: "UW Comments",
  55: "Approved",
  56: "Rejected",
  238: "N/A",
} as const;

export const LLC_AGREEMENT_OPTIONS = [
  { label: "Under Review", value: 54 },
  { label: "UW Comments", value: 146 },
  { label: "Approved", value: 55 },
  { label: "Rejected", value: 56 },
  { label: "N/A", value: 238 },
] as const;

/**
 * IM Staffing Agreement
 * Field ID: 114
 * Field Key: df089dbd00aeff25936cd7e52727446e9170e0d0
 */
export const IM_STAFFING_AGREEMENT = {
  "Under Review": 148,
  "UW Comments": 150,
  Approved: 149,
  Rejected: 151,
  "N/A": 239,
} as const;

export const IM_STAFFING_AGREEMENT_LABELS: Record<number, string> = {
  148: "Under Review",
  150: "UW Comments",
  149: "Approved",
  151: "Rejected",
  239: "N/A",
} as const;

export const IM_STAFFING_AGREEMENT_OPTIONS = [
  { label: "Under Review", value: 148 },
  { label: "UW Comments", value: 150 },
  { label: "Approved", value: 149 },
  { label: "Rejected", value: 151 },
  { label: "N/A", value: 239 },
] as const;

/**
 * IM Indemnity Agreement
 * Field ID: 97
 * Field Key: 7039c4e89839a3eac90c0652af8a1607224b5430
 */
export const IM_INDEMNITY_AGREEMENT = {
  "Under Review": 98,
  "UW Comments": 99,
  Approved: 240,
  Rejected: 241,
  "N/A": 242,
} as const;

export const IM_INDEMNITY_AGREEMENT_LABELS: Record<number, string> = {
  98: "Under Review",
  99: "UW Comments",
  240: "Approved",
  241: "Rejected",
  242: "N/A",
} as const;

export const IM_INDEMNITY_AGREEMENT_OPTIONS = [
  { label: "Under Review", value: 98 },
  { label: "UW Comments", value: 99 },
  { label: "Approved", value: 240 },
  { label: "Rejected", value: 241 },
  { label: "N/A", value: 242 },
] as const;

/**
 * Approval of RA and IM
 * Field ID: 140
 * Field Key: e65448320aed54244c1039be421dd682ae5e699e
 */
export const APPROVAL_OF_RA_AND_IM = {
  "Under Review": 205,
  "UW Comments": 204,
  Approved: 207,
  Rejected: 208,
  "N/A": 243,
} as const;

export const APPROVAL_OF_RA_AND_IM_LABELS: Record<number, string> = {
  205: "Under Review",
  204: "UW Comments",
  207: "Approved",
  208: "Rejected",
  243: "N/A",
} as const;

export const APPROVAL_OF_RA_AND_IM_OPTIONS = [
  { label: "Under Review", value: 205 },
  { label: "UW Comments", value: 204 },
  { label: "Approved", value: 207 },
  { label: "Rejected", value: 208 },
  { label: "N/A", value: 243 },
] as const;

/**
 * EIN Letter
 * Field ID: 123
 * Field Key: 6dd9d85313fd1b3930dd34f86a266286b32b5320
 */
export const EIN_LETTER = {
  Approved: 178,
  Rejected: 179,
  Uploaded: 180,
  "N/A": 244,
} as const;

export const EIN_LETTER_LABELS: Record<number, string> = {
  178: "Approved",
  179: "Rejected",
  180: "Uploaded",
  244: "N/A",
} as const;

export const EIN_LETTER_OPTIONS = [
  { label: "Approved", value: 178 },
  { label: "Rejected", value: 179 },
  { label: "Uploaded", value: 180 },
  { label: "N/A", value: 244 },
] as const;

/**
 * CustomerServiceAgreement_status
 * Field ID: 107
 * Field Key: be50b30f04dde52371f8784399cfdd9c6f6800ef
 */
export const CUSTOMERSERVICEAGREEMENT_STATUS = {
  "Under Review": 123,
  "UW Comments": 144,
  Approved: 124,
  Rejected: 125,
  "N/A": 245,
} as const;

export const CUSTOMERSERVICEAGREEMENT_STATUS_LABELS: Record<number, string> = {
  123: "Under Review",
  144: "UW Comments",
  124: "Approved",
  125: "Rejected",
  245: "N/A",
} as const;

export const CUSTOMERSERVICEAGREEMENT_STATUS_OPTIONS = [
  { label: "Under Review", value: 123 },
  { label: "UW Comments", value: 144 },
  { label: "Approved", value: 124 },
  { label: "Rejected", value: 125 },
  { label: "N/A", value: 245 },
] as const;

/**
 * Proof of Order
 * Field ID: 126
 * Field Key: 8f0b5ffa81cfb4df8a6b66cd3037fc76342be42a
 */
export const PROOF_OF_ORDER = {
  "Under Review": 191,
  "UW Comments": 189,
  Approved: 188,
  Rejected: 190,
  "N/A": 246,
} as const;

export const PROOF_OF_ORDER_LABELS: Record<number, string> = {
  191: "Under Review",
  189: "UW Comments",
  188: "Approved",
  190: "Rejected",
  246: "N/A",
} as const;

export const PROOF_OF_ORDER_OPTIONS = [
  { label: "Under Review", value: 191 },
  { label: "UW Comments", value: 189 },
  { label: "Approved", value: 188 },
  { label: "Rejected", value: 190 },
  { label: "N/A", value: 246 },
] as const;

/**
 * SPV is PO Purchaser
 * Field ID: 121
 * Field Key: 315c4043bf5696debea1933f22d67b6863f6808c
 */
export const SPV_IS_PO_PURCHASER = {
  Yes: 171,
  No: 172,
} as const;

export const SPV_IS_PO_PURCHASER_LABELS: Record<number, string> = {
  171: "Yes",
  172: "No",
} as const;

export const SPV_IS_PO_PURCHASER_OPTIONS = [
  { label: "Yes", value: 171 },
  { label: "No", value: 172 },
] as const;

/**
 * SaleAndContributionAgreement_status
 * Field ID: 105
 * Field Key: 594248e3f510eb68f00d23fd8a8d021c0c7cddc9
 */
export const SALEANDCONTRIBUTIONAGREEMENT_STATUS = {
  "Under Review": 115,
  "UW Comments": 145,
  Approved: 116,
  Rejected: 117,
  "N/A": 247,
} as const;

export const SALEANDCONTRIBUTIONAGREEMENT_STATUS_LABELS: Record<number, string> = {
  115: "Under Review",
  145: "UW Comments",
  116: "Approved",
  117: "Rejected",
  247: "N/A",
} as const;

export const SALEANDCONTRIBUTIONAGREEMENT_STATUS_OPTIONS = [
  { label: "Under Review", value: 115 },
  { label: "UW Comments", value: 145 },
  { label: "Approved", value: 116 },
  { label: "Rejected", value: 117 },
  { label: "N/A", value: 247 },
] as const;

/**
 * WarehouseReceipt_status
 * Field ID: 108
 * Field Key: 11cf615dae47c7843cdee9cae1fa0d0649382c9e
 */
export const WAREHOUSERECEIPT_STATUS = {
  "Under Review": 127,
  "UW Comments": 143,
  Approved: 128,
  Rejected: 129,
  "N/A": 248,
} as const;

export const WAREHOUSERECEIPT_STATUS_LABELS: Record<number, string> = {
  127: "Under Review",
  143: "UW Comments",
  128: "Approved",
  129: "Rejected",
  248: "N/A",
} as const;

export const WAREHOUSERECEIPT_STATUS_OPTIONS = [
  { label: "Under Review", value: 127 },
  { label: "UW Comments", value: 143 },
  { label: "Approved", value: 128 },
  { label: "Rejected", value: 129 },
  { label: "N/A", value: 248 },
] as const;

/**
 * Aravolta
 * Field ID: 127
 * Field Key: 163f44e955eccb05e31b3704ca583b027ca49ef0
 */
export const ARAVOLTA = {
  SSH: 192,
  "No SSH": 193,
} as const;

export const ARAVOLTA_LABELS: Record<number, string> = {
  192: "SSH",
  193: "No SSH",
} as const;

export const ARAVOLTA_OPTIONS = [
  { label: "SSH", value: 192 },
  { label: "No SSH", value: 193 },
] as const;

/**
 * Aravolta_status
 * Field ID: 153
 * Field Key: 0c2321c59c01f1d92574379674d3ee593518cd7c
 */
export const ARAVOLTA_STATUS = {
  Pending: 249,
  Confirmed: 250,
  "N/A": 251,
} as const;

export const ARAVOLTA_STATUS_LABELS: Record<number, string> = {
  249: "Pending",
  250: "Confirmed",
  251: "N/A",
} as const;

export const ARAVOLTA_STATUS_OPTIONS = [
  { label: "Pending", value: 249 },
  { label: "Confirmed", value: 250 },
  { label: "N/A", value: 251 },
] as const;

/**
 * Insurance Quote or NRAI Indemnity
 * Field ID: 90
 * Field Key: bc843483c56f48e64a56389ae236332a2bda20a3
 */
export const INSURANCE_QUOTE_OR_NRAI_INDEMNITY = {
  "Under Review": 62,
  "UW Comments": 61,
  Approved: 63,
  Rejected: 64,
  "N/A": 252,
} as const;

export const INSURANCE_QUOTE_OR_NRAI_INDEMNITY_LABELS: Record<number, string> = {
  62: "Under Review",
  61: "UW Comments",
  63: "Approved",
  64: "Rejected",
  252: "N/A",
} as const;

export const INSURANCE_QUOTE_OR_NRAI_INDEMNITY_OPTIONS = [
  { label: "Under Review", value: 62 },
  { label: "UW Comments", value: 61 },
  { label: "Approved", value: 63 },
  { label: "Rejected", value: 64 },
  { label: "N/A", value: 252 },
] as const;

/**
 * Assets Added to Master Insurance
 * Field ID: 144
 * Field Key: 789ea5e8e06ecd18a78ecd5099bd88d878976edd
 */
export const ASSETS_ADDED_TO_MASTER_INSURANCE = {
  Pending: 218,
  Completed: 219,
  "Under Review": 220,
  Rejected: 221,
  "N/A": 253,
} as const;

export const ASSETS_ADDED_TO_MASTER_INSURANCE_LABELS: Record<number, string> = {
  218: "Pending",
  219: "Completed",
  220: "Under Review",
  221: "Rejected",
  253: "N/A",
} as const;

export const ASSETS_ADDED_TO_MASTER_INSURANCE_OPTIONS = [
  { label: "Pending", value: 218 },
  { label: "Completed", value: 219 },
  { label: "Under Review", value: 220 },
  { label: "Rejected", value: 221 },
  { label: "N/A", value: 253 },
] as const;

/**
 * MLA Received?
 * Field ID: 111
 * Field Key: 7f6628aaa8902d5c6d8ea95f2601601da8c47269
 */
export const MLA_RECEIVED = {
  Yes: 134,
  No: 135,
} as const;

export const MLA_RECEIVED_LABELS: Record<number, string> = {
  134: "Yes",
  135: "No",
} as const;

export const MLA_RECEIVED_OPTIONS = [
  { label: "Yes", value: 134 },
  { label: "No", value: 135 },
] as const;

/**
 * Master mapping of all enum field IDs to their label mappings
 * Note: Some fields use string IDs, others use numeric IDs
 */
export const PIPEDRIVE_ENUM_MAPPINGS: Record<number, Record<number | string, string>> = {
  34: SOURCE_ORIGIN_LABELS as Record<number | string, string>,
  36: SOURCE_CHANNEL_LABELS as Record<number | string, string>,
  38: ARCHIVE_STATUS_LABELS as Record<number | string, string>,
  117: PROBABILITY_OF_CLOSE_LABELS as Record<number | string, string>,
  115: ISTEST_LABELS as Record<number | string, string>,
  98: HARDWARE_SHIPPED_LABELS as Record<number | string, string>,
  100: HARDWARE_INSTALLED_AND_BURN_IN_COMPLETE_LABELS as Record<number | string, string>,
  110: EQUIPMENT_WARRANTY_RECEIVED_LABELS as Record<number | string, string>,
  131: OFFTAKER_LABELS as Record<number | string, string>,
  116: NDA_STATUS_LABELS as Record<number | string, string>,
  113: TERMSHEET_STATUS_LABELS as Record<number | string, string>,
  118: KYB_STATUS_LABELS as Record<number | string, string>,
  89: DATACENTERONEPAGER_STATUS_LABELS as Record<number | string, string>,
  104: PURCHASEORDER_STATUS_LABELS as Record<number | string, string>,
  124: OEM_PAYMENT_TERMS_LABELS as Record<number | string, string>,
  120: ONRAMP_OFFRAMP_LABELS as Record<number | string, string>,
  125: COLOCATIONAGREEMENT_STATUS_LABELS as Record<number | string, string>,
  106: OFFTAKE_AGREEMENT_LABELS as Record<number | string, string>,
  122: BRIDGE_LOAN_LABELS as Record<number | string, string>,
  119: JURISDICTION_REVIEW_LABELS as Record<number | string, string>,
  137: SPV_ONE_STOP_LABELS as Record<number | string, string>,
  139: SPVONESTOP_STATUS_LABELS as Record<number | string, string>,
  87: CERTIFICATE_OF_FORMATION_LABELS as Record<number | string, string>,
  88: LLC_AGREEMENT_LABELS as Record<number | string, string>,
  114: IM_STAFFING_AGREEMENT_LABELS as Record<number | string, string>,
  97: IM_INDEMNITY_AGREEMENT_LABELS as Record<number | string, string>,
  140: APPROVAL_OF_RA_AND_IM_LABELS as Record<number | string, string>,
  123: EIN_LETTER_LABELS as Record<number | string, string>,
  107: CUSTOMERSERVICEAGREEMENT_STATUS_LABELS as Record<number | string, string>,
  126: PROOF_OF_ORDER_LABELS as Record<number | string, string>,
  121: SPV_IS_PO_PURCHASER_LABELS as Record<number | string, string>,
  105: SALEANDCONTRIBUTIONAGREEMENT_STATUS_LABELS as Record<number | string, string>,
  108: WAREHOUSERECEIPT_STATUS_LABELS as Record<number | string, string>,
  127: ARAVOLTA_LABELS as Record<number | string, string>,
  153: ARAVOLTA_STATUS_LABELS as Record<number | string, string>,
  90: INSURANCE_QUOTE_OR_NRAI_INDEMNITY_LABELS as Record<number | string, string>,
  144: ASSETS_ADDED_TO_MASTER_INSURANCE_LABELS as Record<number | string, string>,
  111: MLA_RECEIVED_LABELS as Record<number | string, string>,
};

/**
 * Mapping of field keys to field IDs for easy lookup
 */
export const FIELD_KEY_TO_ID: Record<string, number> = {
  "origin": 34,
  "channel": 36,
  "is_archived": 38,
  "347cda1150789af5a19a0483a0063db455aad424": 117,
  "2b26af4354874e97018e9aad208457f8bf2d5416": 115,
  "e7d7148683c30552ce53721264b3de452939fa1d": 98,
  "f1d989b84b2ad2564e09fd93b99db1ab8d30a83c": 100,
  "00af81541df009d41ee5f5505aa17d7c4d98040b": 110,
  "98a633ff60f37d8478b5757b2bc6d5f6857d5dc8": 131,
  "d7d3dfaba5ea7bb23e45a34a8224fbefad14514c": 116,
  "c19e2651065b0b97646dcec0e7e8528d7c29703c": 113,
  "3c924d0009e3b4ca08591718a762c905eaa7fa19": 118,
  "d5de2fef33e9024ee89b416601dc31a979a3a643": 89,
  "a7b35aa3f095016acce6ce4ea2c3b864f92f64cb": 104,
  "57b1601d582819af391f6ddb4fe5b41368dfb99f": 124,
  "e00ba5b36adfa213c38785d96abb657fec797d9d": 120,
  "243c01f5bee4f2eda200a03cb52295d14a44fab4": 125,
  "bfbca09586600306461ef18e0b9e469480f67df4": 106,
  "209b2db5abba2b15705e7a915f4b3f94afa710e8": 122,
  "33d80ad890272a94b3b87889b8f3e4b7623d68d7": 119,
  "086488add8ab8c59b89a7d90d650463e6fe97c10": 137,
  "5bfcb8aad8382fffa18e4bc2b22ed0211576afd9": 139,
  "6f1ca719cef3b5ec53f9f4394bbf0fd767155819": 87,
  "92c7deb00ea03b7727ff5f40d0343e13dc8736cc": 88,
  "df089dbd00aeff25936cd7e52727446e9170e0d0": 114,
  "7039c4e89839a3eac90c0652af8a1607224b5430": 97,
  "e65448320aed54244c1039be421dd682ae5e699e": 140,
  "6dd9d85313fd1b3930dd34f86a266286b32b5320": 123,
  "be50b30f04dde52371f8784399cfdd9c6f6800ef": 107,
  "8f0b5ffa81cfb4df8a6b66cd3037fc76342be42a": 126,
  "315c4043bf5696debea1933f22d67b6863f6808c": 121,
  "594248e3f510eb68f00d23fd8a8d021c0c7cddc9": 105,
  "11cf615dae47c7843cdee9cae1fa0d0649382c9e": 108,
  "163f44e955eccb05e31b3704ca583b027ca49ef0": 127,
  "0c2321c59c01f1d92574379674d3ee593518cd7c": 153,
  "bc843483c56f48e64a56389ae236332a2bda20a3": 90,
  "789ea5e8e06ecd18a78ecd5099bd88d878976edd": 144,
  "7f6628aaa8902d5c6d8ea95f2601601da8c47269": 111,
};

/**
 * Helper function to get the label for an enum field option
 *
 * @param fieldId - The Pipedrive field ID
 * @param optionId - The option ID returned from the API (can be number, string, or boolean)
 * @returns The human-readable label, or undefined if not found
 *
 * @example
 * const label = getEnumLabel(52, 27); // Returns "Yes" for KYB Passed
 * const label2 = getEnumLabel(34, "API"); // Returns "API" for Source Origin
 */
export function getEnumLabel(fieldId: number, optionId: number | string | boolean): string | undefined {
  const key = typeof optionId === "boolean" ? optionId.toString() : optionId;
  return PIPEDRIVE_ENUM_MAPPINGS[fieldId]?.[key];
}

/**
 * Helper function to get the label for an enum field option by field key
 *
 * @param fieldKey - The Pipedrive field key (hash)
 * @param optionId - The option ID returned from the API (can be number, string, or boolean)
 * @returns The human-readable label, or undefined if not found
 *
 * @example
 * const label = getEnumLabelByKey("a046034af118951a8f9b829c02a78768b0020038", 27); // Returns "Yes"
 */
export function getEnumLabelByKey(fieldKey: string, optionId: number | string | boolean): string | undefined {
  const fieldId = FIELD_KEY_TO_ID[fieldKey];
  if (!fieldId) return undefined;
  return getEnumLabel(fieldId, optionId);
}
